import { Component, computed, inject, input } from '@angular/core';
import { JackpotHrService } from '../jackpot-hr.service';
import { Jackpot } from '../interfaces/jackpot.interface.js';
import { JackpotUserBetComponent } from '../jackpot-user-bet/jackpot-user-bet.component';
import { FairnessButtonComponent } from '../../../core/components/fairness-button/fairness-button.component';
import { CostComponent } from '../../../core/components/cost/cost.component';
import { PlayerRowComponent } from '../../../core/components/player-row/player-row.component';
import { ContextMenuService } from '@core/services/context-menu.service.js';
import { SvgIconComponent } from 'angular-svg-icon';
import { ClipboardService } from '@core/services/clipboard.service.js';
import { ModalService } from '@features/modals/services/modal.service.js';
import { listAnimation } from '@core/utils/animations.util.js';

@Component({
  selector: 'app-jackpot-bets',
  templateUrl: './jackpot-bets.component.html',
  styleUrls: ['./jackpot-bets.component.scss'],
  standalone: true,
  imports: [
    SvgIconComponent,
    JackpotUserBetComponent,
    FairnessButtonComponent,
    CostComponent,
    PlayerRowComponent,
  ],
  animations: [listAnimation],
})
export class JackpotBetsComponent {
  readonly round = input.required<Jackpot>();

  timer = computed(() => {
    const timer = this.jackpotService?.timer();
    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;
    return minutes < 0 || seconds < 0
      ? '00:00'
      : `${minutes < 10 ? '0' : ''}${minutes}:${
          seconds < 10 ? '0' : ''
        }${seconds}`;
  });

  jackpotService = inject(JackpotHrService);
  contextMenuService = inject(ContextMenuService);
  clipboardService = inject(ClipboardService);
  modalService = inject(ModalService);

  openJoinGame() {
    this.modalService.openModal('DepositJackpotModal');
  }
}
